function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ededed;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M41.25,13H6.188A3.187,3.187,0,0,0,3,16.188V40.094a3.188,3.188,0,0,0,3.187,3.188H41.25a3.187,3.187,0,0,0,3.188-3.187V16.188A3.188,3.188,0,0,0,41.25,13ZM25.313,31.9v5.008H22.125V31.9a6.375,6.375,0,1,1,3.188,0Z",
  transform: "translate(0 7.719)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M20.156,0A11.212,11.212,0,0,0,9,11.156v6.375h3.188V11.156a7.969,7.969,0,0,1,15.938,0h3.187A11.214,11.214,0,0,0,20.156,0Z",
  transform: "translate(3.563)"
}));

var SvgUnlocked = function SvgUnlocked(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41.438,
    height: 51,
    viewBox: "0 0 41.438 51",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUnlocked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/unlocked.136c5ca2.svg";
export { ForwardRef as ReactComponent };